import { Status } from "src/app/@core/enums/status.enum";

export interface HomeAdvertisingModel {
    id: number;
    status: Status;
    title: string;
    image: string;
    url: string;
    carouselType: HomeAdvertisingType;
}
export enum HomeAdvertisingType {
    ScrolledCarousel,
    ArrowCarousel
}
